export interface MmMonitoringNavigationIntent {
  batchId: string | null;
  taskId: string | null;
}

function readNavigationId(value: string | null | undefined): string | null {
  if (value === null || value === undefined) {
    return null;
  }

  const trimmed = String(value).trim();

  return trimmed !== '' ? trimmed : null;
}

export function normalizeMonitoringNavigationIntent(
  payload: MmMonitoringNavigationIntent | null | undefined,
): MmMonitoringNavigationIntent | null {
  if (payload === null || payload === undefined) {
    return null;
  }

  const batchId = readNavigationId(payload.batchId);
  const taskId = readNavigationId(payload.taskId);

  if (batchId === null && taskId === null) {
    return null;
  }

  return { batchId, taskId };
}
